// src/pages/Home/Home.js
import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  const programs = [
    {
      name: 'Playgroup',
      age: '2 - 3 Years',
      duration: '3 Hours/Day',
      color: '#FF6B9D',
      icon: '🎈'
    },
    {
      name: 'Pre-Nursery',
      age: '3 - 4 Years',
      duration: '3 Hours/Day',
      color: '#4ECDC4',
      icon: '🎨'
    },
    {
      name: 'Nursery',
      age: '4 - 5 Years',
      duration: '3 Hours/Day',
      color: '#FFD93D',
      icon: '📚'
    },
    {
      name: 'Kindergarten',
      age: '5 - 6 Years',
      duration: '4 Hours/Day',
      color: '#9B59B6',
      icon: '🎓'
    },
    {
      name: 'Daycare',
      age: 'All Ages',
      duration: 'Full Day',
      color: '#FF8C42',
      icon: '🏡'
    }
  ];

  const advantages = [
    {
      title: 'Focus on What is Right for the Child',
      icon: '❤️',
      color: '#FF6B9D'
    },
    {
      title: 'Safety and Security is a Priority',
      icon: '🛡️',
      color: '#4ECDC4'
    },
    {
      title: 'Integrated Pentemind Curriculum',
      icon: '🧠',
      color: '#FFD93D'
    },
    {
      title: 'I Care and Trained Facilitators',
      icon: '👨‍🏫',
      color: '#9B59B6'
    }
  ];

  return (
    <div className="home-page page-content">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-background">
          <div className="hero-shapes">
            <div className="shape shape-1"></div>
            <div className="shape shape-2"></div>
            <div className="shape shape-3"></div>
          </div>
        </div>
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <h1 className="hero-title">
                Welcome to <span className="gradient-text">DisneyLand</span> Preschool
              </h1>
              <p className="hero-subtitle">
                Nurturing Unique Potential in Every Child
              </p>
              <p className="hero-description">
                We believe that there is 'unique potential' in every child; and DisneyLand nurtures it. 
                We nurture and shape minds with the help of our best-in-class age appropriate progressive curriculum.
              </p>
              <div className="hero-buttons">
                <Link to="/admission" className="btn btn-primary">Apply for Admission</Link>
                <Link to="/contact-us" className="btn btn-secondary">Contact Us</Link>
              </div>
            </div>
            <div className="hero-image">
              <div className="hero-image-placeholder">
                <div className="kids-illustration">
                  <span className="kid-emoji">👧</span>
                  <span className="kid-emoji">👦</span>
                  <span className="kid-emoji">🧒</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Why Choose DisneyLand?</h2>
            <div className="title-underline"></div>
          </div>
          <p className="about-intro">
            We encourage, educate, and equip today's children to be tomorrow's leaders.
          </p>
          <div className="advantages-grid">
            {advantages.map((advantage, index) => (
              <div key={index} className="advantage-card" style={{ borderTopColor: advantage.color }}>
                <div className="advantage-icon" style={{ backgroundColor: advantage.color }}>
                  {advantage.icon}
                </div>
                <h3>{advantage.title}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Programs Section */}
      <section className="programs-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Our Programs</h2>
            <div className="title-underline"></div>
            <p className="section-subtitle">
              Age-appropriate curriculum designed for every stage of early childhood development
            </p>
          </div>
          <div className="programs-grid">
            {programs.map((program, index) => (
              <div key={index} className="program-card">
                <div className="program-icon" style={{ backgroundColor: program.color }}>
                  {program.icon}
                </div>
                <h3 className="program-name">{program.name}</h3>
                <div className="program-details">
                  <p className="program-age">
                    <strong>Age:</strong> {program.age}
                  </p>
                  <p className="program-duration">
                    <strong>Duration:</strong> {program.duration}
                  </p>
                </div>
                <Link to="/admission" className="program-btn" style={{ backgroundColor: program.color }}>
                  Learn More
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Vision Mission Section */}
      <section className="vision-section">
        <div className="container">
          <div className="vision-content">
            <div className="vision-box">
              <div className="vision-icon">🎯</div>
              <h3>Our Vision</h3>
              <p>
                We are committed to instilling skills, knowledge, and values in our children in order to give them 
                an inner voice to face the challenges of the twenty-first century.
              </p>
            </div>
            <div className="vision-box">
              <div className="vision-icon">🌟</div>
              <h3>Our Mission</h3>
              <p>
                Our learning environment allows each child to nurture the learning minds namely the Empathetic Mind, 
                Conscientious Mind, Focused Mind, Analytical Mind, and Inventive Mind.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Begin Your Child's Learning Journey?</h2>
            <p>Join the DisneyLand family and give your child the best start in life</p>
            <div className="cta-buttons">
              <Link to="/admission" className="btn btn-white">Enroll Now</Link>
              <Link to="/contact-us" className="btn btn-outline">Schedule a Visit</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;